<template>
  <v-hover v-slot:default="{ hover }">
    <router-link
      style="text-decoration: none;"
      :to="{ name: 'poster', params: { id: poster.id } }"
    >
      <v-card max-width="1100" class="v-card" :elevation="hover ? 16 : 2">
        <v-container>
          <v-row dense>
            <v-col xs="0" sm="4" md="4" lg="4" class="preview-image">
              <v-img contain height="170" :src="`${poster.downloadURL}`" alt>
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
            <v-col xs="12" sm="8" md="8" lg="8">
              <v-list-item>
                <v-list-item-avatar color="grey">
                  <v-img :src="`${poster.downloadURL}`"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline font-weight-bold">{{
                    poster.title
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ poster.authors.join(", ") }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>

              <v-card-text class="text-justify">{{
                poster.description
              }}</v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </router-link>
  </v-hover>
</template>

<script>
export default {
  name: "Card",
  props: ["poster"],
  data: () => ({}),

  methods: {},
};
</script>

<style>
@media screen and (max-width: 601px) {
  .preview-image {
    display: none;
  }
}

.v-card {
  margin: auto;
}
</style>
